import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/interfaces/pcg-table-column.interface';

export class UserWidgetVm {
	userWidgetId: number;
	widgetId: number;
	name?: string;
	userId: number;
	widgetType?: any;
	isOnDashboard: boolean;
	description?: string;
	module?: any;
	minPermission?: any;
	maxPermission?: any;
	widgetPermissionType?: any;
	widgetPermissionRoleIds?: number[];
	isRequired: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userWidgetId': new UntypedFormControl(0, [...(validators['userWidgetId'] ?? []), ...[Validators.required]]),
			'widgetId': new UntypedFormControl(0, [...(validators['widgetId'] ?? []), ...[Validators.required]]),
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[Validators.required, Validators.maxLength(500)]]),
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'widgetType': new UntypedFormControl('', [...(validators['widgetType'] ?? []), ...[Validators.required]]),
			'isOnDashboard': new UntypedFormControl(false, [...(validators['isOnDashboard'] ?? []), ...[]]),
			'description': new UntypedFormControl(null, [...(validators['description'] ?? []), ...[Validators.required, Validators.maxLength(1000)]]),
			'module': new UntypedFormControl(null, [...(validators['module'] ?? []), ...[Validators.required]]),
			'minPermission': new UntypedFormControl(null, [...(validators['minPermission'] ?? []), ...[Validators.required]]),
			'maxPermission': new UntypedFormControl(null, [...(validators['maxPermission'] ?? []), ...[Validators.required]]),
			'widgetPermissionType': new UntypedFormControl('', [...(validators['widgetPermissionType'] ?? []), ...[Validators.required]]),
			'widgetPermissionRoleIds': new UntypedFormControl([], [...(validators['widgetPermissionRoleIds'] ?? []), ...[]]),
			'isRequired': new UntypedFormControl(false, [...(validators['isRequired'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['name', {"orderId":0,"sortColumn":"name","searchColumn":"name","includeInExcel":true,"exportColumns":null,"displayName":"Name","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}],
			['description', {"orderId":1,"sortColumn":"description","searchColumn":"description","includeInExcel":true,"exportColumns":null,"displayName":"Description","isVisible":true,"canSearch":true,"isNdc":false,"isNdc10":false,"isSum":false,"multiSearchCellClasses":null,"requiresFullAccess":false,"cellClass":null,"cellTransform":null,"cellNavigationColumn":null,"canSort":true,"isCurrency":false,"isPercent":false,"isEditableField":false,"headerTooltip":"","isPrint":true,"exportFormat":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): UserWidgetVmFromFg {
		return new UserWidgetVmFromFg(fg);
	}
}

export class UserWidgetVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userWidgetId(): number {
		return this.fg.get('userWidgetId').value;
	}
	set userWidgetId(val) {
		this.fg.get('userWidgetId').setValue(val);
	}

	get widgetId(): number {
		return this.fg.get('widgetId').value;
	}
	set widgetId(val) {
		this.fg.get('widgetId').setValue(val);
	}

	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}

	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get widgetType(): any {
		return this.fg.get('widgetType').value;
	}
	set widgetType(val) {
		this.fg.get('widgetType').setValue(val);
	}

	get isOnDashboard(): boolean {
		return this.fg.get('isOnDashboard').value;
	}
	set isOnDashboard(val) {
		this.fg.get('isOnDashboard').setValue(val);
	}

	get description(): string {
		return this.fg.get('description').value;
	}
	set description(val) {
		this.fg.get('description').setValue(val);
	}

	get module(): any {
		return this.fg.get('module').value;
	}
	set module(val) {
		this.fg.get('module').setValue(val);
	}

	get minPermission(): any {
		return this.fg.get('minPermission').value;
	}
	set minPermission(val) {
		this.fg.get('minPermission').setValue(val);
	}

	get maxPermission(): any {
		return this.fg.get('maxPermission').value;
	}
	set maxPermission(val) {
		this.fg.get('maxPermission').setValue(val);
	}

	get widgetPermissionType(): any {
		return this.fg.get('widgetPermissionType').value;
	}
	set widgetPermissionType(val) {
		this.fg.get('widgetPermissionType').setValue(val);
	}

	get isRequired(): boolean {
		return this.fg.get('isRequired').value;
	}
	set isRequired(val) {
		this.fg.get('isRequired').setValue(val);
	}
}
